import { Endpoints, fetch, normalizeKeys, patch, put, remove } from '../api' // Assuming the 'fetch' function is available in the 'api' module
import { encodeBlueprint } from '@decoders/blueprintDecoder'

export const fetchBlueprints = async () => {
  const uri = `${Endpoints.Report}/Blueprint`
  const response = await fetch(uri)
  return normalizeKeys(response.data)
}

export const createBlueprint = async blueprintData => {
  const uri = `${Endpoints.Report}/Blueprint`
  const response = await patch(uri, {
    body: encodeBlueprint(blueprintData),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return await response.json()
}

export const updateBlueprint = async (blueprintId, blueprintData) => {
  const uri = `${Endpoints.Report}/Blueprint/${blueprintId}`
  const response = await put(uri, {
    method: 'PUT',
    body: encodeBlueprint(blueprintData),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return await response.json()
}

export const fetchReportBlueprint = async blueprintId => {
  const uri = `${Endpoints.Report}/Blueprint/${blueprintId}`
  const response = await fetch(uri)
  const reportBlueprint = response.data[0]
  reportBlueprint.children = reportBlueprint.Components
  return normalizeKeys(reportBlueprint)
}

export const deleteBlueprintById = async blueprintId => {
  const uri = `${Endpoints.Report}/Blueprint/${blueprintId}`
  const response = await remove(uri)
  return response.ok
}
